import { render, staticRenderFns } from "./ReportFlagComment.vue?vue&type=template&id=4394ec25&"
import script from "./ReportFlagComment.vue?vue&type=script&lang=js&"
export * from "./ReportFlagComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports